import IO from "socket.io-client";
import config from "./config";
import Value from "./primitives/value";
import Obj from "./primitives/object";
import List from "./primitives/list";

export default class HamoniSync {
  constructor(accountId, appId) {
    this._accountId = accountId;
    this._appId = appId;
  }

  connect() {
    return new Promise((resolve, reject) => {
      this._io = IO(config.serverUrl, {
        query: {
          appId: this._appId,
          accountId: this._accountId
        }
      });

      this._io.once("connect", () => {
        console.log("connected succesfully");
        resolve();
      });

      this._io.once(
        "connect_error",
        error => console.log("error connecting") || reject(error)
      );

      this._io.once("error", error => reject(error));
    });
  }

  createValue(name, state) {
    return new Promise((resolve, reject) => {
      if (state === null || state === undefined)
        reject("State cannot be empty");
      else if (typeof state === "function" || typeof state === "object")
        reject("State has an invalid type");
      else {
        this._io.emit(
          "create-value",
          { name: name, state: state },
          response => {
            if (response.error) reject(response.error);
            else {
              console.log("success");
              //resolve with an instance of value primitive
              resolve(new Value(this._appId, this._io, name, response));
            }
          }
        );
      }
    });
  }

  createObject(name, state) {
    return new Promise((resolve, reject) => {
      if (typeof state !== "object" || state === null || state === undefined) {
        console.log("... I am invalid");
        reject("State is invalid");
      } else {
        console.log("... I am valid");
        this._io.emit(
          "create-object",
          { name: name, state: state },
          response => {
            if (response.error) reject(response.error);
            else {
              //resolve with an instance of value primitive
              resolve(new Obj(this._appId, this._io, name, response));
            }
          }
        );
      }
    });
  }

  createList(name, state) {
    return new Promise((resolve, reject) => {
      if (
        typeof state.constructor === Array ||
        state === null ||
        state === undefined
      ) {
        reject("State is invalid");
      } else {
        this._io.emit("create-list", { name: name, state: state }, response => {
          if (response.error) reject(response.error);
          else {
            resolve(new List(this._appId, this._io, name, response));
          }
        });
      }
    });
  }

  get(name) {
    return new Promise((resolve, reject) => {
      if (name && typeof name === "string") {
        this._io.emit("get-state", name, response => {
          if (response.error) reject(response.error);
          else {
            //resolve with an instance of primitive type
            if (response.type === "value")
              resolve(new Value(this._appId, this._io, name, response));
            else if (response.type === "object")
              resolve(new Obj(this._appId, this._io, name, response));
            else if (response.type === "list")
              resolve(new List(this._appId, this._io, name, response));
          }
        });
      } else {
        reject("invalid state name passed as parameter");
      }
    });
  }
}
